module.exports = __webpack_public_path__ + "img/text_everyone_pc.5e66d31b.svg";